(function() {
  const STORES = [
    { id: '71508263117', name: 'Reynosa Ribereña', label: 'Reynosa' },
    { id: '57422446797', name: 'Simon Bolívar 1551', label: 'Nuevo Laredo' },
    { id: '71520288973', name: 'Cumbres Mty', label: 'Monterrey' }
  ];

  const SHOP = 'juliana-anzaldua.myshopify.com';
  const STOREFRONT_TOKEN = '123143c586ea05f2875fd3d85b27b238';

  let currentAvailabilityData = null;
  let currentStoreId = null;

  // ─── GUARDAR ATRIBUTO EN EL CARRITO DE SHOPIFY ──────────────────────────────
  async function syncStoreToCart(storeId) {
    const storeObj = STORES.find(s => s.id === storeId);
    if (!storeObj) return;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Sucursal Seleccionada': storeObj.label,
            'Location ID': storeId
          }
        })
      });
      console.log('Sucursal sincronizada con el carrito:', storeObj.label);
    } catch (err) {
      console.error('Error sincronizando carrito:', err);
    }
  }

  // ─── POPUP DE BIENVENIDA ───────────────────────────────────────────────────

  function showCityPopup() {
    if (localStorage.getItem('selected_store')) return;

    const overlay = document.createElement('div');
    overlay.id = 'city-selector-overlay';
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.55);
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      animation: fadeIn 0.3s ease;
    `;

    overlay.innerHTML = `
      <style>
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        .city-btn:hover { opacity: 0.85; transform: scale(1.02); }
      </style>
      <div style="
        background: #fff;
        border-radius: 16px;
        padding: 36px 32px;
        max-width: 480px;
        width: 100%;
        text-align: center;
        animation: slideUp 0.3s ease;
        box-shadow: 0 20px 60px rgba(0,0,0,0.2);
      ">
        <div style="font-size: 32px; margin-bottom: 12px;">📍</div>
        <h2 style="margin: 0 0 8px; font-size: 20px; font-weight: 700; color: #111; font-family: inherit;">¿En qué ciudad deseas comprar?</h2>
        <p style="margin: 0 0 28px; font-size: 14px; color: #888; font-family: inherit;">Selecciona tu ciudad para ver la disponibilidad correcta</p>
        <div style="display: flex; gap: 10px; justify-content: center; flex-wrap: wrap;">
          ${STORES.map(store => `
            <button
              type="button"
              class="city-btn"
              data-store-id="${store.id}"
              style="
                flex: 1;
                min-width: 120px;
                padding: 14px 10px;
                border: 2px solid #111;
                border-radius: 10px;
                background: #fff;
                color: #111;
                font-size: 14px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.15s ease;
                font-family: inherit;
              "
            >
              📍 ${store.label}
            </button>
          `).join('')}
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    overlay.querySelectorAll('.city-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const storeId = this.dataset.storeId;
        localStorage.setItem('selected_store', storeId);
        currentStoreId = storeId;

        syncStoreToCart(storeId);

        overlay.style.transition = 'opacity 0.25s ease';
        overlay.style.opacity = '0';
        setTimeout(() => overlay.remove(), 250);

        updateWidgetSelection(storeId);
      });
    });
  }

  function updateWidgetSelection(storeId) {
    document.querySelectorAll('.store-selector-btn').forEach(b => {
      b.style.background = b.dataset.storeId === storeId ? '#000' : '#fff';
      b.style.color = b.dataset.storeId === storeId ? '#fff' : '#333';
    });
    if (currentAvailabilityData) updateUI(storeId);
  }

  // ─── WIDGET DE PRODUCTO ────────────────────────────────────────────────────

  function getCurrentVariantId() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return null;
    const input = form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function getSelectedQuantity() {
    const qtyInput = document.querySelector('.quantity__input, input[name="quantity"]');
    return qtyInput ? parseInt(qtyInput.value) || 1 : 1;
  }

  async function getStoreAvailability(variantId) {
    const query = `{
      node(id: "gid://shopify/ProductVariant/${variantId}") {
        ... on ProductVariant {
          storeAvailability(first: 10) {
            edges {
              node {
                available
                quantityAvailable
                location {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }`;

    try {
      const res = await fetch(`https://${SHOP}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query })
      });
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function createWidget(selectedStore) {
    const existing = document.getElementById('store-availability-widget');
    if (existing) existing.remove();

    const widget = document.createElement('div');
    widget.id = 'store-availability-widget';
    widget.style.cssText = `
      margin: 16px 0;
      font-family: inherit;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      overflow: hidden;
    `;

    widget.innerHTML = `
      <div style="padding: 12px 16px; background: #f9f9f9; border-bottom: 1px solid #e8e8e8;">
        <p style="margin: 0; font-size: 13px; color: #666; font-weight: 500;">¿En qué tienda compras?</p>
      </div>
      <div style="display: flex; border-bottom: 1px solid #e8e8e8; flex-wrap: wrap;">
        ${STORES.map(store => `
          <button
            type="button"
            class="store-selector-btn"
            data-store-id="${store.id}"
            style="
              flex: 1;
              padding: 10px;
              border: none;
              background: ${selectedStore === store.id ? '#000' : '#fff'};
              color: ${selectedStore === store.id ? '#fff' : '#333'};
              font-size: 13px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.2s;
              border-right: 1px solid #e8e8e8;
              min-width: 100px;
            "
          >
            📍 ${store.label}
          </button>
        `).join('')}
      </div>
      <div id="store-availability-status" style="padding: 12px 16px; font-size: 13px; color: #666;">
        <span>Verificando disponibilidad...</span>
      </div>
    `;

    return widget;
  }

  function showStatus(selected, others) {
    const status = document.getElementById('store-availability-status');
    if (!status) return;

    let html = '';

    if (selected.available && selected.qty > 0) {
      html += `
        <span style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
          <span style="width: 8px; height: 8px; border-radius: 50%; background: #2e7d32; display: inline-block; flex-shrink: 0;"></span>
          <span style="color: #2e7d32; font-weight: 500;">Disponible en ${selected.label} — ${selected.qty} pieza${selected.qty !== 1 ? 's' : ''}</span>
        </span>
      `;
    } else {
      html += `
        <span style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
          <span style="width: 8px; height: 8px; border-radius: 50%; background: #c62828; display: inline-block; flex-shrink: 0;"></span>
          <span style="color: #c62828; font-weight: 500;">Agotado en ${selected.label}</span>
        </span>
      `;
    }

    others.forEach(other => {
      if (other.available && other.qty > 0) {
        html += `<div style="font-size: 12px; color: #555; margin-top: 2px;">✓ Disponible en ${other.label} — ${other.qty} pieza${other.qty !== 1 ? 's' : ''}</div>`;
      }
    });

    status.innerHTML = html;
  }

  function setAddToCartState(available, qty) {
    const btn = document.querySelector('.product-form__submit');
    if (!btn) return;

    const selectedQty = getSelectedQuantity();

    if (!available || qty <= 0) {
      btn.disabled = true;
      btn.style.opacity = '0.4';
      btn.style.pointerEvents = 'none';
      hideQtyWarning();
    } else if (selectedQty > qty) {
      btn.disabled = true;
      btn.style.opacity = '0.4';
      btn.style.pointerEvents = 'none';
      showQtyWarning(qty, selectedQty);
    } else {
      btn.disabled = false;
      btn.style.opacity = '1';
      btn.style.pointerEvents = 'auto';
      hideQtyWarning();
    }
  }

  function showQtyWarning(maxQty, requestedQty) {
    let warning = document.getElementById('store-qty-warning');
    if (!warning) {
      warning = document.createElement('div');
      warning.id = 'store-qty-warning';
      const widget = document.getElementById('store-availability-widget');
      if (widget) widget.parentElement.insertBefore(warning, widget.nextSibling);
    }
    warning.style.cssText = `
      margin: -8px 0 12px;
      padding: 10px 14px;
      background: #fff3cd;
      border: 1px solid #ffc107;
      border-radius: 6px;
      font-size: 13px;
      color: #856404;
    `;
    warning.innerHTML = `⚠️ Solo hay <strong>${maxQty}</strong> pieza${maxQty !== 1 ? 's' : ''} disponibles en esta tienda. Estás pidiendo ${requestedQty}.`;
  }

  function hideQtyWarning() {
    const warning = document.getElementById('store-qty-warning');
    if (warning) warning.remove();
  }

  // ─── EVALUACIÓN DE DISPONIBILIDAD ──────────────────────────────────────────

  function parseAvailability(data, storeId) {
    const edges = data?.data?.node?.storeAvailability?.edges || [];
    let selected = { available: false, qty: 0, label: '' };
    let others = [];

    const graphqlMap = {};
    edges.forEach(edge => {
      const locId = edge.node.location.id.split('/').pop();
      graphqlMap[locId] = {
        available: edge.node.available,
        qty: edge.node.quantityAvailable || 0
      };
    });

    STORES.forEach(store => {
      const gData = graphqlMap[store.id];
      let entry;

      if (gData) {
        entry = {
          available: gData.available,
          qty: gData.qty,
          label: store.label
        };
      } else {
        entry = {
          available: true,
          qty: 2, 
          label: store.label
        };
      }

      if (store.id === storeId) {
        selected = entry;
      } else {
        others.push(entry);
      }
    });

    return { selected, others };
  }

  function updateUI(storeId) {
    if (!currentAvailabilityData) return;
    const { selected, others } = parseAvailability(currentAvailabilityData, storeId);
    showStatus(selected, others);
    setAddToCartState(selected.available, selected.qty);
  }

  async function initProductWidget() {
    if (!window.location.pathname.includes('/products/')) return;

    const variantId = getCurrentVariantId();
    if (!variantId) return;

    currentStoreId = localStorage.getItem('selected_store') || STORES[0].id;
    syncStoreToCart(currentStoreId);

    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) return;

    const widget = createWidget(currentStoreId);
    
    // IMPORTANTE: Lo colocamos ANTES/AFUERA del formulario de compras
    // para que no interfiera en lo absoluto con la inicialización de Bookeasy
    productForm.parentElement.insertBefore(widget, productForm);

    currentAvailabilityData = await getStoreAvailability(variantId);
    updateUI(currentStoreId);

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.store-selector-btn');
      if (btn) {
        const storeId = btn.dataset.storeId;
        currentStoreId = storeId;
        localStorage.setItem('selected_store', storeId);

        syncStoreToCart(storeId);

        document.querySelectorAll('.store-selector-btn').forEach(b => {
          b.style.background = '#fff';
          b.style.color = '#333';
        });
        btn.style.background = '#000';
        btn.style.color = '#fff';

        updateUI(storeId);
      }
    });

    document.addEventListener('change', function(e) {
      if (e.target.name === 'quantity' || e.target.classList.contains('quantity__input')) {
        updateUI(currentStoreId);
      }
    });

    document.addEventListener('click', function(e) {
      if (e.target.closest('.quantity__button, .quantity-button, [data-action="decrement"], [data-action="increment"]')) {
        setTimeout(() => updateUI(currentStoreId), 100);
      }
    });

    document.addEventListener('variantChange', async function(e) {
      const newVariantId = e.detail?.variant?.id || getCurrentVariantId();
      if (newVariantId) {
        currentAvailabilityData = await getStoreAvailability(newVariantId);
        updateUI(currentStoreId);
      }
    });
  }

  // ─── INIT ──────────────────────────────────────────────────────────────────

  function init() {
    showCityPopup();
    initProductWidget();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();